import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { AlertTriangle, Trash } from "lucide-react";

export default function ConfirmarExclusaoModal({
  aberto,
  onFechar,
  onConfirmar,
  item,
}) {
  return (
    <AnimatePresence>
      {aberto && (
        <motion.div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded shadow-md w-[420px]"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {/* Cabeçalho */}
            <div className="bg-[#2f2f2f] text-white px-4 py-2 rounded-t flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Trash size={16} />
                <span className="font-semibold text-sm">
                  Confirmar Exclusão
                </span>
              </div>
              <motion.button
                onClick={onFechar}
                whileHover={{ scale: 1.1 }}
                className="bg-white text-black rounded-full w-6 h-6 flex items-center justify-center text-sm"
              >
                ×
              </motion.button>
            </div>

            {/* Mensagem */}
            <div className="bg-gray-100 px-4 py-3 text-sm text-gray-800 flex items-center gap-2">
              <AlertTriangle size={18} className="text-gray-500 shrink-0" />
              <span>
                Deseja realmente excluir o tipo de serviço{" "}
                <strong>
                  #{item?.id} - {item?.nome}
                </strong>
                ?
              </span>
            </div>

            {/* Botões */}
            <div className="flex justify-center gap-3 py-3 px-4">
              <button
                onClick={onConfirmar}
                className="bg-[#1d7f14] text-white text-sm px-4 py-1.5 rounded"
              >
                ✔ Sim
              </button>
              <button
                onClick={onFechar}
                className="bg-[#bc3823] text-white text-sm px-4 py-1.5 rounded"
              >
                ✖ Não
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
